import type { Accomplishment, MemberSummary } from '@clan-heart/shared';

/**
 * Who the Award form offers, sorted by name: every crew member except the
 * awarding officer (the API refuses self-awards) and, for a normal
 * accomplishment, everyone who already holds it — only a repeatable one can
 * be earned again.
 */
export function awardCandidates(
  members: readonly MemberSummary[],
  accomplishment: Pick<Accomplishment, 'repeatable' | 'holders'>,
  viewerId: string | undefined,
): MemberSummary[] {
  const holderIds = accomplishment.repeatable ? new Set<string>() : new Set((accomplishment.holders ?? []).map((h) => h.id));
  return members
    .filter((m) => m.id !== viewerId && !holderIds.has(m.id))
    .sort((a, b) => a.displayName.localeCompare(b.displayName));
}
